import {Component, Injectable, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";

import {ModalBase} from "../../../services/modal/modal-base";

import {CloudApiService} from "../../../services/cloud-api.service";
import {LibraryGroupDto} from "../../../services/dtos/library-group.dto";
import {UserSessionService} from "../../../services/user-session.service";
import {FormBuilder} from "@angular/forms";
import {PortalLinkDto} from "../../../services/dtos/portal-link.dto";

enum State {
    None,
    Loading,
    Ready
}

@Component({
    selector: 'add-portal-link-modal',
    template: require('./add-portal-link.modal.component.html'),
    styles: [ require('./add-portal-link.modal.component.css') ]
})
export class AddPortalLinkModalComponent implements OnInit {

    states = State;
    state: State = State.None;
    errorMessage: string;
    canSave: boolean = true;
    fileSizeKb: number;
    libraries: LibraryGroupDto[] = [];
    linkForm: any;
    portalLinkDto: PortalLinkDto = new PortalLinkDto();

    constructor(
        public activeModal: NgbActiveModal,
        private userSession: UserSessionService,
        private cloudApiService: CloudApiService,
        private formBuilder: FormBuilder
    ) {}

    ngOnInit(): void {
        this.linkForm = this.formBuilder.group({
            url: '', description: '', image: ''
        });

        this.state = State.Ready;
    }

    public dismiss(): void {
        this.activeModal.dismiss();
    }

    private save(linkForm: any): void {
        this.updateDto(linkForm);

        this.validate();

        if (this.canSave) {
            this.cloudApiService.createPortalLink(this.portalLinkDto)
                .subscribe(() => { this.activeModal.close(); })
        }
    }

    private updateDto(linkForm: any): void {
        this.portalLinkDto.id = 0;
        this.portalLinkDto.url = linkForm.get('url').value;
        this.portalLinkDto.description = linkForm.get('description').value;
    }

    private onFileChange(event: any) {
        let reader = new FileReader();

        if (event.target.files && event.target.files.length > 0) {
            let file = event.target.files[0];
            this.fileSizeKb = file.size / 1024;

            this.validate();

            reader.readAsDataURL(file);

            reader.onload = () => {
                this.portalLinkDto.imageString = reader.result.split(',')[1];
            }
        }
    }

    private validate(): void {
        this.errorMessage = null;

        if (this.portalLinkDto.url == "" || this.portalLinkDto.description == "")
            this.errorMessage = "Url and Description required";

        if (this.fileSizeKb > 100) {
            this.errorMessage = "Icon cannot exceed 100KB";
        }

        this.canSave = this.errorMessage == null;
    }
}

@Injectable()
export class AddPortalLinkModal extends ModalBase {
    constructor(modalService: NgbModal) {
        super(modalService, AddPortalLinkModalComponent)
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/modals/add-portal-link/add-portal-link.modal.component.ts